export default __webpack_public_path__ + "static/media/COVER.8cc95206.jpeg";